module.exports = __webpack_public_path__ + "static/media/ico-email.8153a8c3.svg";